/* src/app/modules/shared/components/header-column/header-column-brand/header-column-brand.component.scss */
app-header-column-brand {
  display: contents;
}
/*# sourceMappingURL=header-column-brand.component.css.map */
